export default __webpack_public_path__ + "static/media/t2.8794a5ad.jpeg";